module.exports = __webpack_public_path__ + "assets/img/footer_banner_service.e2269106.png";